import React from 'react';
import ValidatingInput from '../ValidatingInput/ValidatingInput';

export function OrganizationType(props) {
    const valueObject = types.find(t => t.id === props.dataSet[props.dataKey]);

    return (
        <ValidatingInput
            label={props.label}
            dataSet={props.dataSet}
            dataKey={props.dataKey}
            valueObject={valueObject}
            onChange={props.onChange}
            options={types}
            validationFn={(selectedType) => {
                return types.findIndex(t => t.id === selectedType.id) > -1
            }}
            validationType="select"
        />
    );
}

const types = [
    { id: 1, label: 'Reseller', value: 'Reseller' },
    { id: 2, label: 'Fresh food', value: 'Fresh food' },
    { id: 3, label: 'Vending operator', value: 'Vending operator' }
];
